import { NotificationPage } from '@/pages/buyer/NotificationPage';
import { DesktopNotificationPage } from '@/pages/desktop/DesktopNotificationPage';
import { BottomNavigation } from '@/components/common/BottomNavigation';

export function ResponsiveNotificationPage() {
  return (
    <>
      {/* Mobile version */}
      <div className="lg:hidden">
        <div className="mobile-container bg-white min-h-screen relative">
          <NotificationPage />
          <BottomNavigation activeId="notifications" />
        </div>
      </div>
      
      {/* Desktop version */}
      <div className="hidden lg:block">
        <DesktopNotificationPage />
      </div>
    </>
  );
}